import MyPage from 'pages/organizer/my-page';
import OrganizerProjectList from 'pages/organizer/project';
import OrganizerProjectDetail from 'pages/organizer/project/detail';
import OrganizerProjectItemDetail from 'pages/organizer/project/project-item/detail';

export const OrganizerRoute = [
  {
    path: '/project',
    title: '프로젝트',
    element: <OrganizerProjectList />,
  },
  {
    path: '/project/detail',
    element: <OrganizerProjectDetail />,
  },
  {
    path: '/project/project-item/detail',
    element: <OrganizerProjectItemDetail />,
  },
  {
    path: '/my-page',
    title: '회원정보 관리',
    element: <MyPage />,
  },
];
